import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { DesktopService } from 'src/app/services/desktop.service';

@Component({
    selector: 'app-home-navigation',
    templateUrl: './home-navigation.component.html',
    styleUrls: ['./home-navigation.component.scss']
})
export class HomeNavigationComponent {
    constructor(private navController: NavController, private desktopService: DesktopService) { }

    onHome() {
        if (this.desktopService.isDesktop()) {
            this.navController.navigateBack([{ outlets: { mobile: ['lvb-media-screens'] } }]);
        } else {
            this.navController.navigateBack(['lvb-media-screens']);
        }
    }
}
